import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useRowSelect, useTable } from "react-table";
import { CustomCheckbox } from "../../../../util";
import { Link } from "react-router-dom";
import { Edit } from "@material-ui/icons";
import { useLoading } from "../../../../util/LoadingProvider";
import apiHelper from "../../../../util/ApiHelper";

const useStyles = makeStyles({
  iconBtn: {
    color: "#CCCCCC",
    margin: 5,
  },
});

export default function RoleListingPage(props) {
  const classes = useStyles();
  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref) => <Link ref={ref} {...linkProps} />),
    []
  );
  const [roles, setRoles] = React.useState([]);
  const [data, setData] = React.useState([]);
  const { setLoading } = useLoading();

  const getRoles = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.cinefan.getRoles();
      console.log(result);
      setRoles(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getAdmins = React.useCallback(async () => {
    try {
      setLoading(true);
      const adminArg = [];
      const promiseArg = [];

      roles.forEach((role) => {
        const result = apiHelper.getAdminsById(role.id);
        promiseArg.push(result);
      });

      const results = await Promise.all(promiseArg);

      results.forEach((result, index) => {
        adminArg.push({
          id: roles[`${index}`].id,
          role: roles[`${index}`].name,
          member: result.data.length,
        });
      });

      setData(adminArg);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [roles, setLoading]);

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    if (roles.length > 0) {
      getAdmins();
    }
  }, [roles, getAdmins]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Role",
        accessor: "role",
      },
      {
        Header: "Member",
        accessor: "member",
      },
    ],
    []
  );
  const { getTableProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useRowSelect,
      (hooks) => {
        hooks.visibleColumns.push((columns) => [
          ...columns,
          {
            id: "action",
            // The header can use the table's getToggleAllRowsSelectedProps method
            // to render a checkbox
            Header: () => <div>Action</div>,
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) => (
              <div>
                <IconButton
                  className={classes.iconBtn}
                  size="small"
                  component={CustomLink}
                  to={
                    row.original.role
                      ? `/cinefan/permission/manage/${row.original.id}`
                      : ""
                  }
                >
                  <Edit fontSize="small" />
                </IconButton>
              </div>
            ),
          },
        ]);
      }
    );
  console.log(data);
  return (
    // data.length > 0 && (
    <Box>
      <Typography variant="h4" gutterBottom>
        User Permission
      </Typography>

      <Paper>
        <Table aria-label="simple table" component="ul" {...getTableProps()}>
          <TableHead component="div">
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell
                    {...column.getHeaderProps()}
                    style={{
                      paddingTop: 12,
                      paddingBottom: 12,
                    }}
                  >
                    {column.render("Header")}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <TableRow {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <TableCell
                        {...cell.getCellProps()}
                        style={{
                          paddingTop: 6,
                          paddingBottom: 6,
                          color: "#306F9D",
                        }}
                      >
                        {cell.render("Cell")}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    </Box>
    // )
  );
}
